<script setup>
import { computed } from 'vue';
import RadioCard from 'dashboard/components-next/radioCard/RadioCard.vue';
import { AUTOMATION_RUN_TYPES } from '../constants';

const props = defineProps({
  // "Depois de esperar" depende da flag delayed_automations; "Em uma data" está sempre disponível.
  allowsWait: {
    type: Boolean,
    default: false,
  },
});

const runType = defineModel({
  type: String,
  default: AUTOMATION_RUN_TYPES.INSTANT,
});

const RUN_TYPE_OPTIONS = [
  {
    value: AUTOMATION_RUN_TYPES.INSTANT,
    id: 'automation_run_instantly',
    i18nKey: 'INSTANT',
  },
  {
    value: AUTOMATION_RUN_TYPES.WAIT,
    id: 'automation_run_after_wait',
    i18nKey: 'WAIT',
  },
  {
    value: AUTOMATION_RUN_TYPES.DATE,
    id: 'automation_run_on_date',
    i18nKey: 'ON_DATE',
  },
];

const visibleOptions = computed(() =>
  RUN_TYPE_OPTIONS.filter(
    option => option.value !== AUTOMATION_RUN_TYPES.WAIT || props.allowsWait
  )
);

const onSelect = id => {
  runType.value = RUN_TYPE_OPTIONS.find(option => option.id === id).value;
};
</script>

<template>
  <div class="flex flex-col gap-2">
    <label class="mb-0">
      {{ $t('AUTOMATION.ADD.FORM.RUN_TYPE.LABEL') }}
    </label>
    <div
      class="grid gap-3"
      :class="visibleOptions.length > 2 ? 'sm:grid-cols-3' : 'sm:grid-cols-2'"
    >
      <RadioCard
        v-for="option in visibleOptions"
        :id="option.id"
        :key="option.id"
        :label="
          $t(`AUTOMATION.ADD.FORM.RUN_TYPE.OPTIONS.${option.i18nKey}.LABEL`)
        "
        :description="
          $t(
            `AUTOMATION.ADD.FORM.RUN_TYPE.OPTIONS.${option.i18nKey}.DESCRIPTION`
          )
        "
        :is-active="runType === option.value"
        @select="onSelect"
      />
    </div>
  </div>
</template>
